module.exports = __webpack_public_path__ + "static/media/nav-multiplication.f803b219.svg";